import { render, staticRenderFns } from "./EmailSafeImage.vue?vue&type=template&id=65187f6c&scoped=true"
import script from "./EmailSafeImage.vue?vue&type=script&lang=js"
export * from "./EmailSafeImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65187f6c",
  null
  
)

export default component.exports